interface BaseModel {
  id: number;
}
abstract class Model<T extends BaseModel> {
  protected raw: T;

  constructor(raw: T) {
    this.raw = raw;
  }

  static updateArray<T extends BaseModel>(array: T[], value: T): T[] {
    return array.map(item => (item.id === value.id ? value : item));
  }

  public getId() {
    return this.raw.id;
  }

  public toJson(): T {
    return this.raw;
  }
}

export default Model;
